import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import AlertDialogView from './alert-dialog.component.html';

@Component({
  selector: 'alert-dialog',
  template: AlertDialogView
})
export class AlertDialogComponent implements OnInit {
  @Input() title: string = '';
  @Input() message: string = '';
  @Input() visible: boolean = false;
  @Output() onHide: EventEmitter<void> = new EventEmitter<void>();
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
  }

  hiding() {
    this.visibleChange.emit(false);
    this.onHide.emit();
  }

}
